import { Module } from "vuex";
import { RootState } from "@/store/types";
import { mailNotifyTemplate } from "@/store/mail_notify/templates";
import { managementServices } from "@/store/mail_notify/management_services";
import { managementTemplates } from "@/store/mail_notify/management_templates";
import { mailNotifyStatistic } from "@/store/mail_notify/statistic";

export const mailNotifyModule: Module<any, RootState> = {
  modules: {
    mailNotifyTemplate,
    managementServices,
    managementTemplates,
    mailNotifyStatistic,
  },
};
